import { render } from "./Npc.vue?vue&type=template&id=0efa4d34"
import script from "./Npc.vue?vue&type=script&lang=js"
export * from "./Npc.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__